var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fontBlog"},[_c('navbar'),(_vm.groupedData && _vm.allDatas)?_c('sektorler-detail-vue',{attrs:{"sections":_vm.groupedData[15]}}):_vm._e(),_c('footer-vue',{attrs:{"AdressData":_vm.AdressData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }